<template>
    <div id="app">
        <notifications group="message" position="top right" animation-type="velocity"/>
        <header-agency />
        <router-view></router-view>
        <cookie-law theme="dark-lime" buttonText="Accetto">
            <div slot="message">
                Accetta la nostra politica privacy. Più dettagli <router-link to="legal-notes">qui</router-link>
            </div>

        </cookie-law>

    </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import HeaderAgency from './components/Header.vue';
    export default {
        name: 'app',
        components: { CookieLaw, HeaderAgency }
    }
</script>

